import {
  OverallTokenUsage,
  OverallTokenUsageValues,
} from '@features/admin-token-usage/types';
import useDataFetcher from '@hooks/useDataFetcher/useDataFetcher.ts';
import { urls } from '@api/urls.ts';

const useOverallTokenUsage = (): OverallTokenUsageValues => {
  const { data, isLoading } = useDataFetcher<OverallTokenUsage>({
    url: urls.openAI.overallTokenUsage,
  });

  return {
    data,
    isLoading,
  };
};

export default useOverallTokenUsage;
